/** Gutter field from DynamicDataTable. Not a data column. */
export const OVERVIEW_GUTTER_FIELD = "__gutter";

export type HeaderBox = {
  field: string;
  left: number;
  right: number;
  text: string;
};

/**
 * Data columns to hide so the Overview card does not paint a cut header.
 *
 * A header counts as cut only when its box starts inside the clip and ends
 * past it. A header that is already fully past the edge is not a cut.
 * Hide the cut column and every data column after it. Never hide the gutter.
 * Never hide the first data column: that would blank the card.
 */
export function overviewColumnsToHide(
  headers: HeaderBox[],
  clipRight: number,
  columnFields: string[]
): string[] {
  const cut = headers.find(
    (header) =>
      header.field !== OVERVIEW_GUTTER_FIELD &&
      header.text.trim().length > 0 &&
      header.left < clipRight - 1 &&
      header.right > clipRight + 1
  );
  if (!cut) return [];
  const dataFields = columnFields.filter(
    (field) => field !== OVERVIEW_GUTTER_FIELD
  );
  if (dataFields[0] === cut.field) return [];
  const at = columnFields.indexOf(cut.field);
  if (at < 0) return [];
  return columnFields
    .slice(at)
    .filter((field) => field !== OVERVIEW_GUTTER_FIELD);
}
